import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import React, { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import { HomePage } from "./pages/HomePage";
import { HomeLayout } from "./layouts/HomeLayout";
import { NewsLayout } from "./layouts/NewsLayout";
import { EventsLayout } from "./layouts/EventsLayout";
import { ArticlesLayout } from "./layouts/ArticlesLayout";
import { AboutTheFriendsPage } from "./pages/AboutTheFriendsPage";
import { NewsListPage } from "./pages/News/NewsListPage";
import { NewsDetailPage } from "./pages/News/NewsDetailPage";
import { EventsListPage } from "./pages/Events/EventsListPage.jsx";
import { EventDetailPage } from "./pages/Events/EventDetailPage.jsx";
import {ArticleListPage} from "./pages/Articles/ArticleListPage";
import {ArticleDetailPage} from "./pages/Articles/ArticleDetailPage";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { MembershipPage } from "./pages/MembershipPage.jsx";
import { ReportAnIssuePage } from "./pages/ReportAnIssuePage";
import { VolunteeringPage } from "./pages/VoluteeringPage";
import { StaticArticleLayout } from "./layouts/StaticArticleLayout.jsx";
import { imagePreloader, UrlFixer } from "./utils/utils";
import CookieConsent from "react-cookie-consent";
import { HelmetProvider } from "react-helmet-async";
import { PrivacyPolicy } from "./pages/PrivacyPolicy";
import { NotFoundPage } from "./pages/NotFoundPage";

const queryClient = new QueryClient();

const imageList = [
  UrlFixer("/assets/carousel/FQW_Trees.jpg"),
  UrlFixer("/assets/carousel/FQW_Mushrooms.jpg"),
  UrlFixer("/assets/carousel/FQW_Stumps.jpg")
];

function App() {

  useEffect(() => {
    imagePreloader(imageList);
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <HelmetProvider>
      <CookieConsent
        buttonText="Accept All"
        declineButtonText="Essential Only"
        enableDeclineButton
        onAccept={() => { /* handle Accept All */ }}
        onDecline={() => { /* handle Essential Only */ }}
      >
        We use cookies to enhance your experience. By clicking "Accept All", you consent to all cookies. By clicking "Essential Only", only strictly necessary cookies will be used.
      </CookieConsent>
      <Routes>
        <Route path="/" element={<HomeLayout />}>
          <Route path="/" element={<HomePage />} />
        </Route>
        <Route path="/news" element={<NewsLayout />}>
          <Route path="/news/list" element={<NewsListPage />} />
          <Route
            path="/news/list/f?/:filterType?/:filterValue?/:filterExtra?"
            element={<NewsListPage />}
          />
          <Route
            path="/news/list/p?/:page?"
            element={<NewsListPage />}
          />
          <Route path="/news/:id/:slug" element={<NewsDetailPage />} />
        </Route>
        <Route path="/events" element={<EventsLayout />}>
          <Route path="/events/list" element={<EventsListPage />} />
          <Route path="/events/:id/:slug" element={<EventDetailPage />} />
        </Route>
        <Route path="/articles" element={<ArticlesLayout />}>
          <Route path="/articles/list" element={<ArticleListPage />} />
          <Route path="/articles/list/tag/:tagId/:tagLabel" element={<ArticleListPage />} />
          <Route path="/articles/:id/:slug" element={<ArticleDetailPage />} />
        </Route>
        <Route path="/membership" element={<StaticArticleLayout />}>
          <Route index element={<MembershipPage />} />
        </Route>
        <Route path="/static" element={<StaticArticleLayout />}>
          <Route path="/static/report-an-issue" element={<ReportAnIssuePage />}></Route>
          <Route path="/static/volunteering" element={<VolunteeringPage />}></Route>
          <Route path="/static/about-the-friends" element={<AboutTheFriendsPage />}></Route>
          <Route path="/static/privacy-policy" element={<PrivacyPolicy />}></Route>
        </Route>
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
      </HelmetProvider>
    </QueryClientProvider>
  );
}

export default App;
